var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 19.7137C12.546 19.7137 14.9878 18.7023 16.7881 16.9019C18.5885 15.1016 19.5999 12.6598 19.5999 10.1137C19.5999 7.56762 18.5885 5.12583 16.7881 3.32548C14.9878 1.52513 12.546 0.513702 9.9999 0.513702C7.45382 0.513702 5.01203 1.52513 3.21168 3.32548C1.41133 5.12583 0.399902 7.56762 0.399902 10.1137C0.399902 12.6598 1.41133 15.1016 3.21168 16.9019C5.01203 18.7023 7.45382 19.7137 9.9999 19.7137ZM14.4483 8.5621C14.6669 8.33578 14.7878 8.03266 14.7851 7.71802C14.7824 7.40338 14.6562 7.10241 14.4337 6.87992C14.2112 6.65743 13.9102 6.53123 13.5956 6.52849C13.2809 6.52576 12.9778 6.64671 12.7515 6.8653L8.7999 10.8169L7.2483 9.2653C7.02198 9.04671 6.71886 8.92576 6.40422 8.92849C6.08958 8.93123 5.78861 9.05743 5.56612 9.27992C5.34363 9.50241 5.21743 9.80338 5.21469 10.118C5.21196 10.4327 5.33291 10.7358 5.5515 10.9621L7.9515 13.3621C8.17654 13.5871 8.4817 13.7134 8.7999 13.7134C9.1181 13.7134 9.42327 13.5871 9.6483 13.3621L14.4483 8.5621Z",
    fill: "#5AC484"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.357906d2.svg";
export { ForwardRef as ReactComponent };